import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

import { useRef, useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { getBaseHost, compareBaseHosts } from "../../utils/urlUtil";
import Loading from "../../utils/Loding";

function TrackingLinks(props:any) {
  const { loadingClinkURLs, showClinkData, previewLink  } : { loadingClinkURLs: boolean, showClinkData: any, previewLink: string } = props;
  const linkTextareaRef = useRef(null);
  const deepLinkTextareaRef = useRef(null);

  const [deepLink, setDeepLink] = useState("");

  const handleClick = (event:any) => event.target.select();
  const handleCopyToClipboard = (ref:any, link:string) => {
    if (ref && ref.current) {
      ref.current.select();
      navigator.clipboard.writeText(link);
    }
  };

  const encondeDeepLinkOnUrlDest = (link:string) => {
    if (!deepLink) return link;
    return link.match(/url.dest={.*}/) ? link.replace(/url.dest={.*}/, "url.dest=" + encodeURIComponent(deepLink)) : link + "&url.dest=" + encodeURIComponent(deepLink);
  };

  /**
   * @param urlString 
   * @returns 0: invalid
   *          1: valid but without domain
   *          2: valid with domain
   */
  const checkUrl = (urlString:string) => {
    try { 
      new URL(urlString);
      if (previewLink) {
        if (compareBaseHosts(previewLink, urlString)) {
          return 2;
        }
      }
      return 1;
    }
    catch(e) { 
      return 0; 
    }
  }

  return (
    <>
      {
        (loadingClinkURLs) ? <Loading /> :
        (
          showClinkData && 
          <div>
            <div className="alert alert-success"> {showClinkData.publisher} - {showClinkData.appID} - {showClinkData.platform} </div>
            {
              showClinkData && showClinkData.links && Object.keys(showClinkData.links).map((linkName:string) => {
                const link = showClinkData.links[linkName] ;
                return (
                  <div key={linkName}>
                    <div style={{ marginBottom: "10px" }}>
                      <Form.Label>{linkName}</Form.Label>
                      <Form.Control
                        as="textarea" rows={5} type="textarea" readOnly={true}
                        onClick={handleClick} ref={linkTextareaRef}
                        style={{ width: "100%", margin: "10px 0 20px 0" }} value={link}
                      />

                      <Button
                        className="btn btn-secondary"
                        onClick={() => handleCopyToClipboard(linkTextareaRef, link)}
                      >
                        Copy to clipboard (without deep-link)
                      </Button>

                      <hr style={{ margin: "20px 0 10px 0" }} />

                      <Form.Label style={{ whiteSpace: "nowrap", padding: "0.3rem 0" }}>Deep Link</Form.Label>
                      <Form.Control
                        as="textarea" rows={5} type="textarea" placeholder={`enter a URL, like: ${previewLink}`}
                        onChange={(e) => setDeepLink(e.target.value)}
                        style={{ width: "100%", margin: "10px 0 20px 0" }}
                      />

                      {
                        (() => {
                          if (deepLink) {
                            const deepLinkForm = (
                              <>
                                <Form.Label style={{ display: "block" }}>
                                  <span>Tracking link with deep link to </span>
                                  <a href={deepLink} target="_blank" rel="noreferrer">{deepLink}</a>
                                </Form.Label>
                                <Form.Control
                                  as="textarea" rows={5} type="textarea" readOnly={true}
                                  onClick={handleClick} ref={deepLinkTextareaRef}
                                  style={{ width: "100%", margin: "10px 0 20px 0" }} value={encondeDeepLinkOnUrlDest(link)}
                                />
                                <Button
                                  className="btn btn-secondary"
                                  onClick={() => handleCopyToClipboard(deepLinkTextareaRef, encondeDeepLinkOnUrlDest(link))}
                                >
                                  Copy to clipboard (with deep-link)
                                </Button>
                              </>
                            );
                            switch(checkUrl(deepLink)) {
                              case 0:
                                return (
                                  <>
                                    <Alert variant="danger">
                                      Invalid deep link url
                                    </Alert>
                                  </>
                                );
                              case 1:
                                return (
                                  <>
                                    <Alert variant="warning" style={{ padding: "0.75rem" }}>
                                      <FontAwesomeIcon icon={faWarning} style={{ marginRight: "10px" }} />
                                      Deep link domain [{ getBaseHost(deepLink) }] does not match campaign domain [{ getBaseHost(previewLink) }].
                                    </Alert>
                                    {deepLinkForm}
                                  </>
                                );
                              case 2:
                                return (
                                  <>{deepLinkForm}</>
                                );
                            }
                          } else {
                            return (
                              <Alert variant="info">
                                <FontAwesomeIcon icon={faInfoCircle} style={{ marginRight: "10px" }} />
                                Enter a destination URL above to generate a tracking link that deep-links to a specific URL.
                              </Alert>
                            )
                          }
                        })()
                      }
                    </div>
                  </div>
                );
              })
            }
          </div>
        )
      }
    </>
  );
}

export default TrackingLinks;